import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function ValidateRegistrationKeys() : ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {
        if (control.value && control.value != '') {
            const formattedRegKeys = control.value.replace(/[^a-zA-Z0-9 ]/g, ',');
            let allKeysList = formattedRegKeys.split(",").filter((data)=> data != '');
            if(allKeysList.length > 50) {
                return { invalidRegKeys: true };
            } else {
                return null;
            }
          }
          return null;        
    }
}